/**
 * ComplianceBanner — mandatory research-use disclaimer per Temble.
 *
 * Rendered once in App.js directly below the Header so it is visible on
 * every gated storefront page without obscuring navigation or the cart.
 * Does NOT render on the always-public /official microsite — which is
 * explicitly a landing page outside the gated store.
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export const ComplianceBanner = () => {
    const { pathname } = useLocation();
    if (pathname.startsWith("/official")) return null;

    return (
        <div
            role="note"
            aria-label="Research-use compliance notice"
            data-testid="compliance-banner"
            className="w-full border-y border-white/10 bg-black/80 backdrop-blur-md"
            style={{
                background:
                    "linear-gradient(90deg, rgba(0,0,0,0.95) 0%, rgba(10,15,20,0.95) 50%, rgba(0,0,0,0.95) 100%)",
            }}
        >
            <div className="container-x py-2 flex items-center justify-center gap-2.5">
                <AlertTriangle
                    size={13}
                    className="text-[var(--neon-cyan,#4FD1D9)] shrink-0"
                    aria-hidden="true"
                />
                <p className="text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.18em] text-white/85 text-center leading-snug">
                    Not for human use, for research purposes only
                </p>
            </div>
        </div>
    );
};
